export const ActionTypes = {
    loginActions: {
        SET_USER_PROFILE: "SET_USER_PROFILE"
    }
}